import React from 'react';
import { Grid } from '@mui/material';
import { useAuth } from '../context/AuthContext';

/** Renders children only when the role may view this widget (no Grid wrapper). */
export function WidgetGate({ id, children }) {
  const { canViewWidget } = useAuth();
  if (!canViewWidget(id)) return null;
  return children;
}

/**
 * Renders dashboard widget content only when the current role has permission.
 */
const DashboardWidget = ({ id, children, ...gridProps }) => {
  const { canViewWidget } = useAuth();

  if (!canViewWidget(id)) {
    return null;
  }

  return (
    <Grid item {...gridProps}>
      {children}
    </Grid>
  );
};

export default DashboardWidget;
